import { IAdapterServiceMock } from "./adapter.types";

export const mockAdapterService = (): IAdapterServiceMock => ({
  getAssignableAdapters: jest.fn(),
  getCountryAdaptersByCountryCodeAndNonAssignable: jest.fn(),
  patchCountryAdaptersByCountryCodeAndNonAssignable: jest.fn(),
});
